import { inject, Injectable } from '@angular/core';

import { GTM_LOADED_EVENT } from 'src/shared/constants/gtm/gtm-is-loaded-event';
import { LIVE_PREVIEW_PATH, WYSIWYG_PATH } from 'src/shared/constants/paths/paths';
import { clearUrl } from 'src/shared/helpers/clear-url/clear-url';

import { EnvironmentService } from '../environment/environment.service';
import { ScriptTemplateService } from '../script-template/script-template.service';
import { UrlService } from '../url/url.service';

@Injectable({
    providedIn: 'root',
})
export class GtmInitializerService {
    private readonly scriptTemplateService = inject(ScriptTemplateService);
    private readonly environmentService = inject(EnvironmentService);
    private readonly urlService = inject(UrlService);

    private readonly URL_TRIGGER_SUBSTR_FOR_GTM_DELAY = 'fad3ba85e2h4';
    private readonly PATHS_WITH_GTM_DISABLED = [`/${WYSIWYG_PATH}/`, `/${LIVE_PREVIEW_PATH}/`];

    public init(): void {
        this.initializeGtm();
    }

    private initializeGtm(): void {
        const pathname = clearUrl(this.urlService.getPathnameOutsideRouter() || '/');
        const isGtmDisabled = this.PATHS_WITH_GTM_DISABLED.includes(pathname);
        const isGtmDelayTriggered = pathname?.includes?.(this.URL_TRIGGER_SUBSTR_FOR_GTM_DELAY);

        const gtmSelector = '[data-script-id="gtm-ssr"]';
        const gtmApplyProps = {
            'data-gtm-id': this.environmentService.environment.gtmCode,
            'data-gtm-loaded-event': GTM_LOADED_EVENT,
        };

        if (isGtmDelayTriggered && !isGtmDisabled) {
            this.scriptTemplateService.delayScriptTemplate(gtmSelector, gtmApplyProps);
        } else if (!isGtmDisabled) {
            this.scriptTemplateService.applyScriptTemplate(gtmSelector, gtmApplyProps);
        }
    }
}
